import styled from "styled-components";
import { themevals as theme } from "theme/themevals";

interface CustomProps {
  $active?: boolean;
  $submitting?: boolean;
  $customStyles?: {[key: string]: string};
  $isFixed?: boolean;
  size?: any
}

export const TableTop = styled.div<CustomProps>`  
  margin-bottom: 5px;
  width: 100%;  
`

export const TableBottom = styled.div<CustomProps>`
  display: flex;
  flex-wrap: wrap-reverse;
  justify-content: space-between;
  margin-top: 20px;
  width: 100%;
`

export const TableWrapper = styled.div<CustomProps>`
  width: 100%;  
  background-color: ${theme?.colors?.white};
  border-radius: 5px;
  overflow: auto;
  ${(props) => props.$customStyles}
`;

export const Table = styled.table<CustomProps>`
  width: 100%;  
  ${(props) => props.$isFixed ? `table-layout: fixed;`:``}
  ${(props: any) => props.size === "sm" ? `
    font-size: .875rem;
    thead th,
    tfoot th { padding: 6px 10px!important; }
    tbody td{    
      padding: 6px 10px!important;    
      & > div {margin: -6px -10px!important; padding: 6px 10px!important;}
      & > a {margin: -6px -10px!important; padding: 6px 10px!important;}
    }
  `:``}
`;

export const TableHeader = styled.thead`
  width: 100%;
  tr{
    border-radius:6px;}
  th{
    padding:14px 20px;
    font-weight:500;
    font-size:12px;
    font-family:"Poppins";
    color:${theme?.colors?.dkgrey};
    background:#F8F8F8;
    border:none;
    cursor:pointer;
    & div span {
      width: 100%;
    }
         &:first-child{
        border-radius: 6px 0 0 6px;}
  }
  th:last-child{
    border-radius: 0 6px 6px 0; 
  }
`;

export const TableFooter = styled.tfoot`
  width: 100%;
  th{
    padding:14px 30px;
    font-weight:600;
    font-size:14px;
    color:${theme?.colors?.base_700};
    cursor:pointer;
    & div span {
      width: 100%;
    }
   
  tr {
    
  }

`;

export const TableBody = styled.tbody`
  width: 100%;
  td{
    
    padding:14px 20px;
    font-family:"Poppins";
    font-size:14px;
    cursor:default;
    color:${theme?.colors?.dkgrey};
    & > div {margin: -14px -20px; padding:14px 20px;}
    & > a {display: block; margin: -14px -20px; padding:14px 20px; text-decoration: none; color: ${theme?.colors?.base_700};}
    & > a:hover {color: ${theme?.colors?.base_700}; }
  }
  tr{
    border-bottom: 1px solid #EBEBEB;
    cursor:pointer;
    &:hover{
        
    }
  }
  tr:first-child{
   
  }  
  tr:last-child {
    
  }

  tr td:first-child {
    min-width: 275px;
  }
`;

export const CellInner = styled.div`
  display: flex;
  gap: 0px;
  align-items:flex-start;
  text-align:left;
`;

export const TableActions = styled.div`
  display:flex;
  align-items: center;
  justify-content: space-between!important;  
  flex-wrap: wrap;    
  flex: 0 1 auto; 
  gap: 15px 30px; 
  margin-bottom: 15px;
  & form { display: block; flex-grow: 1 }
`;

export const TableFilters = styled.div<CustomProps>`
  display: ${props => (props.$active ? "flex" : "none")};
  position: fixed;
  inset: 0;
  z-index: 1042;
  align-items: center;
  justify-content: center;
`;

export const FiltersBackdrop = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(32, 38, 45, 0.45);
`;

export const FiltersWrap = styled.div<CustomProps>`
  position: relative;
  width: min(440px, 92%);
  max-height: 90vh;
  overflow-y: auto;
  background: ${theme?.colors?.white};
  border-radius: 10px;
  box-shadow: 0 24px 60px rgba(18, 34, 64, 0.18);
  display: flex;
  flex-direction: column;
  gap: 18px;
  z-index: 1;
`;

export const FiltersHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 20px;
  h5{
  margin:0;}
`;

export const FiltersBody = styled.div<CustomProps>`
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 0px 20px 20px 20px;
  ${(props) => props.$customStyles};
`;

export const FiltersFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  border-top: 1px solid ${theme?.colors?.inputOutline};
  padding: 20px;
`;

export const TableBtns = styled.div`
  margin-left: auto;
  display: flex;
  justify-content: flex-end;
  gap: 20px;
  & button { 
    min-height: 36px;
  }
`;

export const TablePagination = styled.div`
  display:flex;
  flex-wrap: wrap;
  align-items: center;
  color: ${theme?.colors?.base_700}!important;
  gap: 10px 20px;
  font-size: .875rem;
  & .page-count{
    display: flex;
    align-items: center;
  }
  & button {
    cursor: pointer;
    width: 36px;
    text-align: center;
    border-radius: 4px;
    padding: 3px!important;
    border-color: ${theme?.colors?.mdgrey}!important;
    background-color: ${theme?.colors?.white};
    & svg {height: 10px; width: auto;}
    &.btn-next svg ,&.btn-last svg {transform: scaleX(-1);}
  }
  & .react-select__control {
    min-height: auto;
    max-height:34px;
    margin: 0 .25rem;
    font-family:Poppins;
    & .react-select__indicator {padding: 1px 8px!important;}
    & .react-select__indicator svg {height: 10px!important; width: auto!important;}
    & .react-select__indicator-separator {display: none;}
  }  
`;

export const TPdiv = styled.div`
  display:flex; flex-wrap: no-wrap; align-items: center;
  gap: 0 10px;
  font-family:Poppins;
  font-size:14px;
`;

export const NumRecords = styled.div`
  display:flex; flex-wrap: no-wrap; align-items: center;
  font-family:Poppins;
  font-size:14px;
`;

export const TPdivMobileHidden = styled.div`
  display: none;
  font-family:Poppins;
  @media (min-width: 992px)  {    
    display:flex; flex-wrap: no-wrap; align-items: center;
  }
`;

export const ModalClose = styled.button`
  
  padding: .5rem;
  margin: 0 0 0 auto;
  cursor: pointer;    
  align-self:flex-start;
  box-sizing: content-box;
  width: .5rem;
  height: .5rem;
  padding: 3px;
  color: #000;
  background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23818181'%3e%3cpath d='M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e");
  background-size: cover;
  background-repeat: no-repeat;
  border: 0;
  border-radius: .375rem;
  opacity: 1;
  cursor: pointer !important;
  &:hover {
    opacity: 0.75;
    cursor: pointer !important;
  }

  &:focus {
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
    opacity: 1;
  }

  &:disabled {
    opacity: 0.25;
  }
`;